<template>
  <div class="RecordButton"
    @touchstart="onTouch(true)"
    @touchend="touchEnd(false)"> 

    <!-- <img :src="require('@/commons/img/record.png')"> -->

    <div class="RecordButton__icon" :class="{ over: over }">  

      <svg viewBox="0 0 92.18 92.18">
        <path class="cls-1" d="M46.09,10A36.09,36.09,0,1,1,10,46.09,36.13,36.13,0,0,1,46.09,10m0-10A46.09,46.09,0,1,0,92.18,46.09,46.1,46.1,0,0,0,46.09,0Z"/>
        <circle class="cls-2" cx="46.09" cy="46.09" r="36.79"/>
        <path class="cls-3" d="M46.09,25a6.32,6.32,0,0,0-6.32,6.32V44a6.32,6.32,0,0,0,12.64,0V31.36A6.32,6.32,0,0,0,46.09,25Z"/>
        <path class="cls-3" d="M39.77,42.41H33.49v1.78a12.61,12.61,0,0,0,25.21,0V42.41H52.41"/>
        <line class="cls-3" x1="46.09" y1="56.79" x2="46.09" y2="67.14"/>
        <line class="cls-3" x1="37.91" y1="67.14" x2="54.27" y2="67.14"/>
        <circle id='circle' cx="46" cy="46" r="40" fill="none" stroke="#a19cc0" stroke-width="10"/>
      </svg>

     <!--  <svg viewBox="0 0 92.18 92.18">
        <path class="cls-1" d="M46.09,10A36.09,36.09,0,1,1,10,46.09,36.13,36.13,0,0,1,46.09,10m0-10A46.09,46.09,0,1,0,92.18,46.09,46.1,46.1,0,0,0,46.09,0Z"/>
        <circle class="cls-2" cx="46.09" cy="46.09" r="36.79"/>
        <path class="cls-3" d="M35.7,33.33l8.72-8.72a2.38,2.38,0,0,1,1.67-.69,2.31,2.31,0,0,1,1.55.58L37.25,34.88Z"/>
        <rect class="cls-3" x="43.16" y="36.66" width="14.69" height="2.19" transform="translate(112.92 28.73) rotate(135)"/>
        <rect class="cls-3" x="38.74" y="32.24" width="14.69" height="2.19" transform="translate(102.25 24.31) rotate(135)"/>
        <path class="cls-3" d="M57.29,37.24l1.55-1.55,8.73,8.73a2.38,2.38,0,0,1,.12,3.22Z"/>
        <rect class="cls-3" x="53.33" y="43.16" width="2.19" height="14.7" transform="translate(128.63 47.73) rotate(134.99)"/>
        <rect class="cls-3" x="57.75" y="38.74" width="2.19" height="14.7" transform="translate(133.05 37.06) rotate(134.99)"/>
        <rect class="cls-3" x="34.32" y="53.33" width="14.69" height="2.19" transform="translate(109.63 63.45) rotate(135)"/>
        <path class="cls-3" d="M46.09,68.26a2.33,2.33,0,0,1-1.54-.57L54.93,57.3l1.55,1.55-8.72,8.72A2.32,2.32,0,0,1,46.09,68.26Z"/>
        <rect class="cls-3" x="38.74" y="57.75" width="14.69" height="2.19" transform="translate(120.3 67.87) rotate(135)"/>
        <rect class="cls-3" x="36.68" y="34.31" width="2.19" height="14.77" transform="translate(93.97 44.47) rotate(135)"/>
        <path class="cls-3" d="M24.61,47.76a2.36,2.36,0,0,1-.69-1.67,2.29,2.29,0,0,1,.58-1.54L34.93,55l-1.55,1.55Z"/>
        <rect class="cls-3" x="32.26" y="38.73" width="2.19" height="14.77" transform="translate(-22.84 37.1) rotate(-45.01)"/>
        <circle id='circle' cx="46" cy="46" r="40" fill="none" stroke="#a19cc0" stroke-width="10"/>
      </svg>
 -->
     <!--  <svg viewBox="0 0 27.71 44.6">
        <path class="cls-1" d="M13.86,1.25A6.32,6.32,0,0,0,7.54,7.57V20.21a6.32,6.32,0,0,0,12.64,0V7.57A6.32,6.32,0,0,0,13.86,1.25Z"/>
        <path class="cls-1" d="M7.54,18.62H1.25V20.4a12.61,12.61,0,0,0,25.21,0V18.62H20.18"/>
        <line class="cls-1" x1="13.86" y1="33" x2="13.86" y2="43.35"/>
        <line class="cls-1" x1="5.68" y1="43.35" x2="22.03" y2="43.35"/>
      </svg> -->

    </div>

  </div> 
</template>

<script>

import gsap from "gsap"
import DrawSVGPlugin from "gsap/DrawSVGPlugin"
gsap.registerPlugin(DrawSVGPlugin)

export default {

  name: 'RecordButton',
  data: ()=>({
    over: false
  }),

  mounted() {
     gsap.set('#circle', { drawSVG:'0%', transformOrigin:"50% 50%", rotate: -90 })
  },

  methods:{
    onTouch(b) {
      // console.log('onTouch '+ b);
      this.$store.commit('app/UPDATE_STATUS', 'start_recording')
      // this.$parent.txt = 'Recording'
      this.over = true
      gsap.to('#circle', { drawSVG:'0% 100%', duration: 10, onComplete: ()=> this.recordCompleted() })
    },
    touchEnd(b) {
      this.recordCompleted()   
    },
    recordCompleted() {
      this.$store.commit('app/UPDATE_STATUS', 'stop_recording')
      this.$parent.txt = ''
      this.$parent.onClick()
      this.over = false
    },
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.RecordButton  
  position relative
  width 9vh
  height 9vh

  &__icon

    & svg
      .cls-1
        fill #916ac9 

      .cls-2 
        fill #6c3eac 

      .cls-3 
        fill none 
        stroke #fff 
        stroke-linecap round 
        stroke-linejoin round 
        stroke-width 2.5px 

    &.over
      & svg
        .cls-2
          fill #ffffff
        .cls-3
          stroke #6c3eac

</style>


